import CartItem from "@api/types/cart-item";
import { GiftItemTooltipHtml, Tooltip } from "@kcc/ui";
import { FC, useContext, useEffect, useState } from "react";

import UserContext from "@components/UserContext";

const CartGiftSelector: FC<{ item: CartItem }> = ({ item }) => {
  const [checked, setChecked] = useState(false);
  const { changeProduct } = useContext(UserContext);

  useEffect(() => {
    setChecked(item.attributes.find((a) => a.name === "gift" && a.value === "true") !== undefined);
  }, [item]);

  return (
    <>
      <div className="CartGiftSelector">
        <input
          checked={checked}
          type="checkbox"
          onChange={({ target: { checked } }) => {
            changeProduct({
              id: item.id,
              setAttribute: [{ name: "gift", value: checked + "" }],
            });
          }}
        />
        <span>gift item</span>
        <Tooltip html={GiftItemTooltipHtml} themeColor="rgb(236, 31, 0)" />
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .CartGiftSelector {
            display: flex;
            align-items: center;
          }
        `}
      </style>
    </>
  );
};

export default CartGiftSelector;
